export const utils = {
  namespaced: true,
  state: {
    isLoadingOverlay: false,
  },
  mutations: {
    setIsLoadingOverlay(state, payload) {
      state.isLoadingOverlay = payload
      console.log('isLoading is set to:', state.isLoadingOverlay)
    },
  },
}



